import { delay } from 'lodash';
import Core from '../Core';

export default async function noActionTaken() {
  return new Promise((resolve) => {
    Core.showMessage('No actions were taken.');
    delay(() => {
      Core.hideMessage();
      resolve();
    }, 1333);
  })
}